import { useEffect, useState } from 'react';
import { FigmaAutoLayout } from './FigmaLayout';
import { Group1244831445, Group1244831449, GoldPageRoot } from './GoldFigmaComponents';
import { pxH, pxW } from './figmaScale';
import { FIGMA_SPEC } from './figmaSpec';
import styles from './GoldProcessingPage.module.scss';
import sparkles from '../../images/gold/Sparkles.png';

const P = FIGMA_SPEC.processing;

function GoldProcessingPage({ progress: externalProgress }) {
  const [progress, setProgress] = useState(12);

  useEffect(() => {
    if (typeof externalProgress === 'number') {
      setProgress(externalProgress);
      return undefined;
    }
    const id = setInterval(() => {
      setProgress((v) => (v >= 92 ? v : v + 2));
    }, 1200);
    return () => clearInterval(id);
  }, [externalProgress]);

  return (
    <GoldPageRoot bg="final">
      <FigmaAutoLayout
        direction="vertical"
        align="center"
        justify="center"
        className={styles.slide151}
        style={{
          flex: 1,
          width: '100%',
          minHeight: 0,
          paddingLeft: pxW(48),
          paddingRight: pxW(48),
          gap: pxH(56),
        }}
      >
        <h1
          className={styles.textTitleUpper}
          style={{
            fontSize: pxH(P.title.fontSize),
            maxWidth: pxW(P.title.w),
            margin: 0,
          }}
        >
          Casting Your Portrait in Gold
        </h1>

        <Group1244831445
          percent={progress}
          ringStyle={{
            width: pxH(P.ring.w),
            height: pxH(P.ring.h),
          }}
        />

        <Group1244831449 sparkleSrc={sparkles} animateIcon />
      </FigmaAutoLayout>
    </GoldPageRoot>
  );
}

export default GoldProcessingPage;
